var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.onClick}},[_c('router-link',{class:['a-nav-mode-button', _vm.modeClass],attrs:{"to":{
            name: _vm.pathName,
            params: {
                itemId: _vm.itemId, 
                mode: _vm.mode
            }
        },"type":"button","tag":"button"}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }